import { useState, useEffect } from 'react';
import {
  Box, Container, Typography, Card, CardContent, CircularProgress, Chip, Grid, Alert,
} from '@mui/material';
import { DirectionsBus, Schedule, Place } from '@mui/icons-material';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;
const hdrs = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export default function ParentTransport() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/fleet/my-transport`, { headers: hdrs() })
      .then(r => setRows(r.data))
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Box textAlign="center" py={8}><CircularProgress /></Box>;

  return (
    <Container maxWidth="md" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
      <Box py={{ xs: 2, sm: 3 }}>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <DirectionsBus color="primary" />
          <Typography variant="h5" fontWeight={800}>School Bus</Typography>
        </Box>

        {rows.length === 0 ? (
          <Alert severity="info">None of your children are set up for the school bus. Contact the school office to opt in.</Alert>
        ) : rows.map(r => (
          <Card key={r.admNo} elevation={2} sx={{ mb: 2, borderRadius: 2 }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1} mb={1} flexWrap="wrap">
                <Typography variant="h6" fontWeight={700}>{r.name}</Typography>
                <Chip size="small" label={r.classCode} />
                <Chip size="small" color={r.usage === 'One-way' ? 'warning' : 'primary'} variant="outlined" label={r.usage} />
                <Chip size="small" color={r.status === 'Active' ? 'success' : 'default'} variant="outlined" label={r.status} />
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box display="flex" alignItems="center" gap={1}><Place fontSize="small" color="action" />
                    <Typography variant="body2"><strong>Pickup stage:</strong> {r.pickupStage || '—'}</Typography></Box>
                  <Box display="flex" alignItems="center" gap={1}><Place fontSize="small" color="action" />
                    <Typography variant="body2"><strong>Drop-off stage:</strong> {r.dropoffStage || '—'}</Typography></Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box display="flex" alignItems="center" gap={1}><Schedule fontSize="small" color="action" />
                    <Typography variant="body2"><strong>Pickup:</strong> {r.pickupTime || '—'} &nbsp; <strong>Departure:</strong> {r.departTime || '—'}</Typography></Box>
                  <Box display="flex" alignItems="center" gap={1}><DirectionsBus fontSize="small" color="action" />
                    <Typography variant="body2"><strong>Morning bus:</strong> {r.morningBus || 'Not assigned'} &nbsp; <strong>Evening:</strong> {r.eveningBus || 'Not assigned'}</Typography></Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container>
  );
}
